export const AriseFeesFields = {
	PlatformSetupFee: {
		name: "arisePlatformSetupFee",
		displayName: "Platform",
		displayFullName: "Platform Setup Fee",
		beName: "arisePlatformSetupFee",
	},
	PlatformMonthlyFee: {
		name: "arisePlatformMonthlyFee",
		displayName: "Platform",
		displayFullName: "Platform Monthly Fee",
		beName: "arisePlatformMonthlyFee",
	},
	CustomerVaultMonthlyFee: {
		name: "ariseCustomerVaultMonthlyFee",
		displayName: "Customer Vault",
		displayFullName: "Customer Vault Monthly Fee",
		beName: "ariseCustomerVaultMonthlyFee",
	},
	EnhancedDataTransactionFee: {
		name: "ariseL2L3EnhancedDataTransactionFee",
		displayName: "L2/L3 Enhanced Data Transaction",
		displayFullName: "L2/L3 Enhanced Data Transaction Fee",
		beName: "ariseL2L3EnhancedDataTransactionFee",
	},
	CardTransactionAuthorizationFee: {
		name: "ariseCardTransactionAndAuthorizationFee",
		displayName: "Card Transaction & Authorization",
		displayFullName: "Card Transaction & Authorization Fee",
		beName: "ariseCardTransactionAndAuthorizationFee",
	},
	ECommercePluginSetupFee: {
		name: "ariseECommercePluginSetupFee",
		displayName: "eCommerce Plugin",
		displayFullName: "eCommerce Plugin Setup Fee",
		beName: "ariseECommercePluginSetupFee",
	},
	ECommercePluginMonthlyFee: {
		name: "ariseECommercePluginMonthlyFee",
		displayName: "eCommerce Plugin",
		displayFullName: "eCommerce Plugin Monthly Fee",
		beName: "ariseECommercePluginMonthlyFee",
	},
	EMVDeviceSetupFee: {
		name: "ariseEMVDeviceSetupFee",
		displayName: "EMV Device",
		displayFullName: "EMV Device Setup Fee",
		beName: "ariseEMVDeviceSetupFee",
	},
	AdditionalEmvDeviceMonthlyFee: {
		name: "ariseAdditionalEMVDeviceMonthlyFee",
		displayName: "EMV Device",
		displayFullName: "Additional EMV Device Monthly Fee",
		beName: "ariseAdditionalEMVDeviceMonthlyFee",
		sign: "(first device included with Platform Monthly Fee)",
	},
	EnhancedDataSetupFee: {
		name: "ariseL2L3EnhancedDataSetupFee",
		displayName: "L2/L3 Enhanced Data",
		displayFullName: "L2/L3 Enhanced Data Setup Fee",
		beName: "ariseL2L3EnhancedDataSetupFee",
	},
	CustomerVaultSetupFee: {
		name: "ariseCustomerVaultSetupFee",
		displayName: "Customer Vault",
		displayFullName: "Customer Vault Setup Fee",
		beName: "ariseCustomerVaultSetupFee",
	},
	CustomerVaultAutomaticUpdateFee: {
		name: "ariseCustomerVaultAutomaticUpdateFee",
		displayName: "Customer Vault Update",
		displayFullName: "Customer Vault Automatic Update Fee",
		beName: "ariseCustomerVaultAutomaticUpdateFee",
	},
	MobileInvoicingPaymentsSetupFee: {
		name: "ariseMobileInvoicingAndPaymentsSetupFee",
		displayName: "Mobile Invoicing & Payments",
		displayFullName: "Mobile Invoicing and Payments Setup Fee",
		beName: "ariseMobileInvoicingAndPaymentsSetupFee",
		sign: "(requires Customer Vault)",
	},
	MobileInvoicingPaymentsMonthlyFee: {
		name: "ariseMobileInvoicingAndPaymentsMonthlyFee",
		displayName: "Mobile Invoicing & Payments",
		displayFullName: "Mobile Invoicing and Payments Monthly Fee",
		beName: "ariseMobileInvoicingAndPaymentsMonthlyFee",
		sign: "(requires Customer Vault)",
	},
	MobileInvoicingPaymentsMessageFee: {
		name: "ariseMobileInvoicingAndPaymentsMessageFee",
		displayName: "Mobile Invoicing & Payments Message",
		displayFullName: "Mobile Invoicing and Payments Message Fee",
		beName: "ariseMobileInvoicingAndPaymentsMessageFee",
		sign: "(requires Customer Vault)",
	},
	// Card Network Tokenization Service Fees
	CardNetworkTokenizationSetupFee: {
		name: "cardNetworkTokenizationSetupFee",
		displayName: "Network Tokenization",
		displayFullName: "Setup Fee",
		beName: "cardNetworkTokenizationSetupFee",
	},
	CardNetworkTokenizationMonthlyFee: {
		name: "cardNetworkTokenizationMonthlyFee",
		displayName: "Network Tokenization",
		displayFullName: "Monthly Fee",
		beName: "cardNetworkTokenizationMonthlyFee",
	},
	CardNetworkPerTokenizationEventFee: {
		name: "cardNetworkPerTokenizationEventFee",
		displayName: "Network Tokenization",
		displayFullName: "Per Tokenization Event Fee",
		beName: "cardNetworkPerTokenizationEventFee",
	},
};
